import React, { useEffect, useMemo ,useState} from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {ModalProgressBar} from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/customers/customersActions";
import {useCustomersUIContext} from "../CustomersUIContext";

export function CustomerDeleteDialog({ id, show, onHide }) {

     const history = useHistory()
     const [isDeleting, setisDeleting] = useState(false)

  // Customers UI Context
  const authtoken = useSelector(state => state.user.authtoken)

  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      setIds: customersUIContext.setIds,
      queryParams: customersUIContext.queryParams
    };
  }, [customersUIContext]);

  // Customers Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.customers.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteCustomer = () => {
    setisDeleting(true)

  

      // console.log(id)
      fetch(`http://portal.darearqamsgd.edu.pk/api/staffmember/${id}`, {
          method: 'DELETE',
          headers: {
              // 'Accept': 'application/json',
              // 'Content-Type': 'application/json',
              'Authorization': `Bearer ${authtoken}`
          },
      }).then(res => res.json()
          .then(data => {
              if (data.metadata.success == true) {
                    onHide()  
                    alert.show('Deleted Successfully')
                    setisDeleting(false)

                    history.push('/staff')              
              }
          })

      ).catch(err => {
        console.log(err)
        setisDeleting(false)
        alert.show('Data Failed')
      })
  

  
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {isLoading && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Staff Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this Staff?</span>
        )}
        {isLoading && <span>Staff is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteCustomer}
            className="btn btn-primary btn-elevate"
          >
            <span>Delete</span>
            {isDeleting && <span className="ml-3 mr-3 spinner spinner-white"></span>}

          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
